module.exports = __webpack_public_path__ + "static/media/fe_watch.a8ac1a15.png";